module.exports = __webpack_public_path__ + "static/media/shield_1.eed31cd2.png";